const EventEmitter = require('events');

class Emitter extends EventEmitter {
  constructor() {
    if (typeof Emitter.instance === 'undefined') {
      super();
      Emitter.instance = this;
    }
    return Emitter.instance;
  }
}

const instance = new Emitter();

export default instance;
